/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech. harvest form: Handles form interactions
***********************************************************/
import React, { Component } from 'react';
import { NumberInput, Select, SelectField, SelectBlock,
  AutoComplete, RadioButton, CheckBox, DatePicker2 } from '../../inputs';
import { LOCATIONS } from '../../../constants';
import { mapEquipmentForAutoComplete, onDummyComplete,
  mapEmployeeForAutoComplete, packageDashForm } from '../../../utils';

class HarvestReportForm extends Component {
  render() {
    if (!(this.props.employees && this.props.equipmentNo)) return <span></span>;
    return (
      <div>
        <hr />
        <center><b>Report Form</b></center>
        <hr />
        <form id="rep-form" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m6 l6 xl6">
              <RadioButton id={'rep-hand'} name={'rep-type'} label={'Hand'} onClick={(e) => this.props.selectReportType(e.target.id)} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <RadioButton id={'rep-mech'} name={'rep-type'} label={'Mech'} onClick={(e) => this.props.selectReportType(e.target.id)} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m6 l6 xl6">
              <DatePicker2 id={'rep-dateFrom'} label={'Date From'} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <DatePicker2 id={'rep-dateTo'} label={'Date To'} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <Select id={'rep-location'} opts={LOCATIONS} label={'Location'} onChange={(e) => this.props.fetchFieldsByLoc(e.target.value)} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <NumberInput id={'rep-round'} label={'Round'} disabled={this.props.disabled} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <SelectField id={'rep-field'} opts={this.props.fields} label={'Field'}
                onChange={(event) => { this.props.fetchBlocksByField(event.target.value, 'mech-rep-field'); this.props.selectField(event.target.value) }} />
            </div>
            <div className="col s12 m6 l6 xl6">
              <SelectBlock id={'rep-block'} label={'Block No.'} opts={this.props.blocks} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12 xl12">
              <AutoComplete id={'rep-employee'} label={'Employee'}
                  data={mapEmployeeForAutoComplete(this.props.employees)}
                  onComplete={onDummyComplete} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12 xl12">
              <AutoComplete id={'rep-equipmentNo'} label={'Equipment No.'}
                  data={mapEquipmentForAutoComplete(this.props.equipmentNo)}
                  onComplete={onDummyComplete} disabled={this.props.disabled} />
            </div>
          </div>
          <div className="container">
            <div className="col s12 m12 l12 xl12">
              <center>
                <CheckBox id={'rep-csv'} name={'rep-docType'} label={'Excel'} />
              </center>
            </div>
          </div><br /><br />
          <div className="row">
            <center className="mb-2">
              <button className="btn btn-large waves-effect waves-light" type="button"
                onClick={() => this.props.fetchReport(packageDashForm('rep-form'), this.props.employees, this.props.email)}>Run Report</button>
            </center>
          </div>
        </form>
      </div>
    )
  }
}

export default HarvestReportForm;

/*

*/


/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/harvest_report_form.jsx